module.exports = __webpack_public_path__ + "static/media/icone_bible.65d51e9d.svg";